module.exports = __webpack_public_path__ + "static/media/imagenet8.1396e7e6.png";